export const ACTION_TYPES = {
    REQUEST_BCAVALIDATION: 'REQUEST_BCAVALIDATION',
    REQUEST_FAILED_BCACALIDATION: 'REQUEST_FAILED_BCACALIDATION',
    RECEIVE_BCAVALIDATION: 'RECEIVE_BCAVALIDATION',
    // Add new action type for unauthorized
    UNAUTHORIZED_BCAVALIDATION: 'UNAUTHORIZED_BCAVALIDATION'
};

const initialState = {
    entity: '',
    isLoading: false,
    success: -1,
    error: false,
    errorMessage: '', // Add error message field
    errorCode: null,  // Add error code field
    validationCode: ''
};

export const bankValidationActions = {
    requestBankValidation: (norek, nama, pilihBank, validationCode) => async (dispatch) => {
        dispatch({ type: ACTION_TYPES.REQUEST_BCAVALIDATION });
        const url = `api/bca`;
        const token = localStorage.getItem('verificationToken');

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: new Headers({
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({ // Fix JSON formatting
                    nama,
                    norek,
                    pilihBank,
                    validationCode
                })
            });

            // Handle different response statuses
            if (response.status === 401) {
                dispatch({
                    type: ACTION_TYPES.UNAUTHORIZED_BCAVALIDATION,
                    error: {
                        message: 'Session expired. Please login again.',
                        code: 401
                    }
                });
                // Optionally redirect to login or clear token
                localStorage.removeItem('verificationToken');
                return;
            }

            if (!response.ok) {
                let errorMessage = 'An error occurred';
                let errorData = null;

                try {
                    errorData = await response.json();
                    errorMessage = errorData.message || errorMessage;
                } catch (e) {
                    // If JSON parsing fails, use status text
                    errorMessage = response.statusText;
                }

                dispatch({
                    type: ACTION_TYPES.REQUEST_FAILED_BCACALIDATION,
                    error: {
                        message: errorMessage,
                        code: response.status,
                        data: errorData
                    }
                });
                return;
            }

            const entity = await response.json();
            dispatch({ type: ACTION_TYPES.RECEIVE_BCAVALIDATION, entity });

        } catch (error) {
            // Handle network errors or other exceptions
            dispatch({
                type: ACTION_TYPES.REQUEST_FAILED_BCACALIDATION,
                error: {
                    message: 'Network error or server unavailable',
                    code: 500,
                    originalError: error.message
                }
            });
        }
    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case ACTION_TYPES.REQUEST_BCAVALIDATION:
            return {
                ...state,
                isLoading: true,
                error: false,
                errorMessage: '',
                errorCode: null
            };

        case ACTION_TYPES.RECEIVE_BCAVALIDATION:
            return {
                ...state,
                isLoading: false,
                validationCode: '',
                imageHash: Date.now(),
                entity: action.entity,
                error: false,
                errorMessage: '',
                errorCode: null
            };

        case ACTION_TYPES.REQUEST_FAILED_BCACALIDATION:
            return {
                ...state,
                isLoading: false,
                validationCode: '',
                error: true,
                errorMessage: action.error.message,
                errorCode: action.error.code,
                entity: action.error.data || null
            };

        case ACTION_TYPES.UNAUTHORIZED_BCAVALIDATION:
            return {
                ...state,
                isLoading: false,
                validationCode: '',
                error: true,
                errorMessage: action.error.message,
                errorCode: action.error.code,
                entity: null
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/BcaValidation.Reducer.js